/* eslint-disable */
// because legacy

import "bootstrap"
import "eonasdan-bootstrap-datetimepicker"
import "moment/locale/de"
import Dropzone from "dropzone"

import "@bikemap/js/legacy/lib/jquery.mixitup.js"
import '@bikemap/js/legacy/utils'
import '@bikemap/js/legacy/forms'
import '@bikemap/js/legacy/lib/raphael-popup'
import '@bikemap/js/legacy/lib/jquery.ddslick.customized'
import '@bikemap/js/legacy/traininglog-graph'

import { InitPasswordField } from '@bikemap/js/integrations/authentication'
import {
  initTrainingItemButtons, initTrainingEntryTab, initTrainingLogContext, initMergeAccountSettingsContext,
  showProfilePictureDeleteModal, showCoverPictureDeleteModal, initGarminConnectForm, initProfileSettingsContext,
  initDeleteAccountForm, initMergeAccountsForm, initSubscriptionTab
} from '@bikemap/js/legacy/profile'
import actions from '@bikemap/js/legacy/profile/settings/actions'
import { Pagination } from "./components"
import { Storage, STORAGE_KEY_DISPLAY_SETTINGS, getApiHeaders } from '@bikemap/js/utility'
import sessionData from '@bikemap/js/services/sessionData'
import { context, gettext, notifications } from "./services"
import { CHECK_EMAIL_AVAILABLE_URL, CHECK_USERNAME_AVAILABLE_URL } from './settings'
import initGlobal, { initPageHeader, initPageFooter } from '@bikemap/js/integrations/global'
import { initWebAppUrls } from './integrations/global/web-app-links'
import { initReportLinks } from './integrations/support'

initGlobal()
initPageHeader()
initPageFooter()

initReportLinks()

Dropzone.autoDiscover = false

let hasCustomAvatar = context.page('hasCustomAvatar')
let _hasCustomAvatar = hasCustomAvatar
let hasCustomCover
let _hasCustomCover
actions.setNoCustomAvatar = function() {
  hasCustomAvatar = false
  _hasCustomAvatar = false
}
actions.setNoCustomCover = function() {
  hasCustomCover = false
  _hasCustomCover = false
}

$(function() {
  "use strict"

  /**
   * Variable initialization
   */
  var $activeTab
  var $initialSubTab
  var $resultsContainer
  var $noSearchResults
  var initialTitle = document.title
  var savedResults
  var helperElement = document.createElement("textarea")
  var previousAvatarUrl
  var currentAvatarUrl
  var previousCoverUrl
  var currentCoverUrl
  var currentPath
  var coverDropzone
  var coverDropzoneFiles
  var profileImageDropzone
  var profileImageDropzoneFiles
  var formCompleteMessage
  var suppressMessages
  var mapLocationFallback
  var isOwner
  var $breadcrumbList = $("#breadcrumb-list")
  var isNavigatingHistory = false
  var loadedTabs = []
  var activeSubTabs = {
    routes: undefined,
    collections: undefined,
    "training-log": undefined,
    settings: undefined
  }
  var loadedSubTabs = {
    routes: undefined,
    collections: undefined,
    "training-log": undefined,
    settings: undefined
  }

  var tabHelpers = {
    activateTab: function(elem) {
      elem
        .parent()
        .children(".active")
        .removeClass("active")
      elem.addClass("active")
      document.title = elem.text() + " - " + initialTitle
    },
    hideTabContent: function() {
      if ($activeTab) {
        $activeTab.trigger("unload-tab")
      }
      $("#tab_content")
        .children(".active")
        .removeClass("active")
      this.showLoadingSpinner()
    },
    showTabContent: function(name) {
      $activeTab = $("#" + name)
      $activeTab.addClass("active")
    },
    showLoadingSpinner: function() {
      $("#tab-spinner").show()
    },
    hideLoadingSpinner: function() {
      $("#tab-spinner").hide()
      $(".sub-tab-spinner").hide()
    }
  }

  var subTabHelpers = {
    activateTab: function(elem) {
      elem
        .parent()
        .parent()
        .find(".active")
        .removeClass("active")
      elem.addClass("active")
      document.title = elem.text()
    },
    hideTabContent: function(activeTab) {
      activeSubTabs[activeTab].trigger("unload-sub-tab")
      activeSubTabs[activeTab].removeClass("active")
      this.showLoadingSpinner()
    },
    showTabContent: function(activeTab, name) {
      activeSubTabs[activeTab] = $("#" + name)
      activeSubTabs[activeTab].addClass("active")
    },
    showLoadingSpinner: function() {
      $(".sub-tab-spinner").show()
    },
    hideLoadingSpinner: function() {
      $("#tab-spinner").hide()
      $(".sub-tab-spinner").hide()
    }
  }

  // global view_mode and sort_field
  const displaySettings = context.page('displaySettings')
  const profileDisplaySettings = context.page('profileDisplaySettings')
  const localDisplaySettings = JSON.parse(Storage.getItem(STORAGE_KEY_DISPLAY_SETTINGS)) || {}

  var activeLayout = localDisplaySettings.view_mode || profileDisplaySettings.view_mode || "list"
  var activeSortMode = localDisplaySettings.sort_field || profileDisplaySettings.sort_field || "created"

  var isClientSortDifferent = !!(
    (displaySettings && displaySettings.sort_field) &&
    (localDisplaySettings && localDisplaySettings.sort_field) &&
    (displaySettings.sort_field !== localDisplaySettings.sort_field)
  )
  var isClientLayoutDifferent = !!(
    (displaySettings && displaySettings.view_mode) &&
    (localDisplaySettings && localDisplaySettings.view_mode) &&
    (displaySettings.view_mode !== localDisplaySettings.view_mode)
  )

  var subTabConfig = {
    "routes-created": {
      resultsContainer: "#tiles-container-routes-created",
      controlsContainer: "#controls-container-routes-created",
      noResults: "#search-no-routes-created"
    },
    "routes-ridden": {
      resultsContainer: "#tiles-container-routes-ridden",
      controlsContainer: "#controls-container-routes-ridden",
      noResults: "#search-no-routes-ridden"
    },
    "routes-favorites": {
      resultsContainer: "#tiles-container-routes-favorites",
      controlsContainer: "#controls-container-routes-favorites",
      noResults: "#search-no-routes-favorites"
    },
    "routes-tracked": {
      resultsContainer: "#tiles-container-routes-tracked",
      controlsContainer: "#controls-container-routes-tracked",
      noResults: "#search-no-routes-tracked"
    }
  }

  // TODO: Remove context workaround when code is extracted into modules!
  initTrainingLogContext({ isOwner, changeSubTab })
  initProfileSettingsContext({ initDZRemoveButtons })
  initMergeAccountSettingsContext({ changeSubTab, activeSubTabs })

  /*
   * Routes
   */
  function initRoutes(elements, type, layout) {
    $resultsContainer = $(elements.resultsContainer)
    $noSearchResults = $(elements.noResults)

    if (savedResults !== undefined && savedResults[type].results !== "") {
      var mixItUpOptions = {}

      // For ajax requests, updating content is not working
      // since we are using a old version of mixitup, its unclear if thats a bug or wrong usage.
      // as a workaround we are destroying it before reinit
      if ($resultsContainer.mixItUp("isLoaded")) {
        $resultsContainer.mixItUp("destroy")
      }

      if (layout !== undefined) {
        mixItUpOptions.layout = {
          containerClass: layout
        }

        $.outdoorish.initMixItUp(
          $(elements.controlsContainer),
          $resultsContainer,
          mixItUpOptions,
          onLayoutUpdate
        )
      }

      $resultsContainer.empty().mixItUp("append", $(savedResults[type].results))
    }

    showNoResults(savedResults[type].resultCount, $noSearchResults)
    initWebAppUrls($resultsContainer[0])
  }

  async function saveDisplaySettings() {
    const displaySettings = {
      view_mode: activeLayout, // eslint-disable-line camelcase
      sort_field: activeSortMode // eslint-disable-line camelcase
    }

    Storage.setItem(STORAGE_KEY_DISPLAY_SETTINGS, JSON.stringify(displaySettings))

    if (await sessionData.isLoggedIn()) {
      $.ajax({
        url: context.page('apiUserprofileDetailUrl'),
        method: "PATCH",
        data: JSON.stringify({
          // eslint-disable-next-line camelcase
          display_settings: displaySettings,
        }),
        dataType: "json",
        contentType: "application/json",
        headers: getApiHeaders(),
        error: function(jqXHR) {
          notifications.error(jqXHR.statusText)
        }
      })
    }
  }

  /*
   * A callback function to set active layout
   */
  function onLayoutUpdate() {
    if (Object.prototype.hasOwnProperty.call(this, "layout")) {
      activeLayout = this.layout
      saveDisplaySettings()
    }
  }

  function loadRouteData(data, type) {
    savedResults = savedResults || {}
    savedResults[type] = savedResults[type] || {}
    savedResults[type].id = type
    savedResults[type].sorting = savedResults[type].sorting || activeSortMode
    savedResults[type].resultCount = data.result_count
    savedResults[type].page = data.page
    savedResults[type].numPages = data.num_pages
    helperElement.textContent = data.routes
    savedResults[type].results = $(helperElement.value)
  }

  function loadTrainingData(data) {
    savedResults = savedResults || {}
    savedResults["all-trainings"] = savedResults["all-trainings"] || {}
    savedResults["all-trainings"].id = "all-trainings"
    savedResults["all-trainings"].resultCount = data.result_count
    savedResults["all-trainings"].page = data.page
    savedResults["all-trainings"].numPages = data.num_pages
    helperElement.innerHTML = data.trainings
    savedResults["all-trainings"].results = $(helperElement.value)
  }

  function initCreateCollectionForm() {
    $("#add-new-button-wrapper").on("show.bs.dropdown", function() {
      $("#collection-title").trigger("focus")
    })

    $("#collection-visibility").ddslick({
      background: "#fff"
    })

    var $form = $("#create-collection-form")
    // ddslick buttons trigger form submit
    $form.on("submit", function(event) {
      event.preventDefault()
    })

    const $submitBtn = $('.js-submit-collection')
    $submitBtn.on("click", function(event) {
      event.preventDefault()

      $submitBtn.disabled = true
      $submitBtn.addClass("loading-spinner")
      $submitBtn.addClass("spinner-blue")

      $.ajax({
        form: $form,
        url: $form.attr("action"),
        method: "POST",
        data: {
          title: $("#collection-title").val(),
          visibility: $form
            .find("#collection-visibility .dd-selected-value")
            .val()
        },
        headers: { "X-CSRFToken": $.outdoorish.readCookie("csrftoken") },
        success: function(data) {
          if (data.success) {
            location.assign(data.url)
          }
        },
        error: function(jqXHR) {
          notifications.error(jqXHR.statusText)
        },
        complete: function() {
          $submitBtn.removeClass("loading-spinner")
          $submitBtn.removeClass("spinner-blue")
          $submitBtn.disabled = false
        }
      })
    })
  }

  function onSortChange(name, sortLabel) {
    var $currentSortMode = $("#current-sorting-" + name)
    $currentSortMode.html(sortLabel)
    $currentSortMode.append(
      '<i class="i-caret-down"></i>'
    )

    // Mark all inactive subtabs as dirty to have them reload with new sort mode on next navigation
    if(loadedSubTabs && loadedSubTabs.routes) {
      loadedSubTabs.routes.forEach(function(item) {
        if (item === name) {
          return
        }

        $("#" + item + "-link")[0].dataset.dirty = true
      })
    }
  }

  function initPaginationSortLinks(name, pagination) {
    $("#sort-" + name)
      .find(".sort-link")
      .on("click", function(ev) {
        ev.preventDefault()
        activeSortMode = this.dataset.sort
        savedResults[name].sorting = activeSortMode

        // Reset pagination after changing the sort mode
        savedResults[name].page = 1
        pagination.currentPage = 1
        submitSearch(savedResults[name])
        onSortChange(name, $(this).html())
      })
  }

  function showNoResults(resultCount, noResultsContainer) {
    if (resultCount === 0) {
      if (noResultsContainer.hasClass("hidden")) {
        noResultsContainer.removeClass("hidden")
      }
    } else if (!noResultsContainer.hasClass("hidden")) {
      noResultsContainer.addClass("hidden")
    }
  }

  // FIXME: specific to Routes tabs, not yet generalized
  function submitSearch(params) {
    var $resultCount = $("#" + params.id + " #result_count")

    var queryParams = {
      page: params.page || 1,
      routes_only: 1, // eslint-disable-line camelcase
      sort: savedResults[params.id].sorting
    }

    var url = context.page('profileBaseUrl')
    if (params.id === "collections") {
      url += params.id + "/"
    } else if (params.id === "all-trainings") {
      url += "training-log/all/"
    } else {
      url += params.id.split("-")[0] + "/" + params.id.split("-")[1] + "/"
    }

    $.ajax({
      url: url,
      method: "GET",
      headers: isOwner ? { "Is-Owner": "True" } : {},
      data: queryParams,
      traditional: true,
      success: function(data) {
        if (params.id === "all-trainings") {
          loadTrainingData(data.results)
        } else {
          loadRouteData(data.results, params.id)
          saveDisplaySettings()
        }

        if (data.results.result_count === 0) {
          $resultCount.text(data.results.result_count_string)
        } else {
          $resultCount.text(
            (queryParams.page - 1) * data.results.results_per_page +
              1 +
              " - " +
              ((queryParams.page - 1) * data.results.results_per_page +
                data.results.page_results_count) +
              django.gettext(" of ") +
              data.results.result_count_string
          )
        }

        const $tilesContainer = $("#tiles-container-" + params.id)

        $tilesContainer
          .empty()
          .mixItUp("append", $(savedResults[params.id].results))

        initWebAppUrls($tilesContainer[0])

        if (params.id === "all-trainings") {
          initTrainingItemButtons()
        }

        showNoResults(data.results.result_count, $("#search-no-" + params.id))
      }
    })
  }

  /**
   * Settings
   */
  function initDZRemoveButtons() {
    $("#dropzone-profile-picture-remove").off("click")
    $("#dropzone-cover-picture-remove").off("click")
    $("#dropzone-profile-picture-confirm").off("click")
    $("#dropzone-cover-picture-confirm").off("click")

    if (hasCustomAvatar === false) {
      $("#dropzone-profile-picture-remove").hide()
      $("#dropzone-profile-picture-confirm").hide()
    } else {
      $("#dropzone-profile-picture-remove").show()

      if (profileImageDropzone.getQueuedFiles().length === 0) {
        $("#dropzone-profile-picture-confirm").hide()
        $("#dropzone-profile-picture-remove").click(showProfilePictureDeleteModal)
      } else {
        $("#dropzone-profile-picture-confirm").show()
        $("#dropzone-profile-picture-remove").on("click", function() {
          currentAvatarUrl = previousAvatarUrl
          profileImageDropzone.removeAllFiles(true)
        })

        $("#dropzone-profile-picture-confirm").on("click", function() {
          $("#profile-picture-upload-progress").show()
          profileImageDropzone.processQueue()
        })
      }
    }

    if (hasCustomCover === false) {
      $("#dropzone-cover-picture-remove").hide()
      $("#dropzone-cover-picture-confirm").hide()
    } else {
      $("#dropzone-cover-picture-remove").show()

      if (coverDropzone.getQueuedFiles().length === 0) {
        $("#dropzone-cover-picture-confirm").hide()
        $("#dropzone-cover-picture-remove").click(showCoverPictureDeleteModal)
      } else {
        $("#dropzone-cover-picture-confirm").show()
        $("#dropzone-cover-picture-remove").on("click", function() {
          currentCoverUrl = previousCoverUrl
          coverDropzone.removeAllFiles(true)
        })

        $("#dropzone-cover-picture-confirm").on("click", function() {
          $("#cover-picture-upload-progress").show()
          coverDropzone.processQueue()
        })
      }
    }
  }

  function setupMainSettingsForm() {
    var profileImageMessage = {}
    var coverMessage = {}
    var profileImageError
    var coverError
    var coverDropzoneSuccess
    var profileImageDropzoneSuccess

    var $submitButton = $("#account-settings-form").find("[type='submit']")

    var $mergeAccountsLink = $("a#settings-main-merge-accounts-link")

    function resetDropzone(name, url) {
      initDZRemoveButtons()
      $(name + "-upload-text").hide()
      $(name + "-img").attr("src", url)
    }

    profileImageDropzone = new Dropzone("#dropzone-profile-picture", {
      url: context.page('profileBaseUrl') + "settings/upload-avatar/",
      acceptedFiles: ".png,.jpg,.jpeg",
      previewTemplate: document.getElementById(
        "dropzone-preview-template-profile-picture"
      ).innerHTML,
      maxFilesize: 3,
      maxFiles: 1,
      thumbnailHeight: 187,
      thumbnailWidth: 187,
      paramName: "avatar_image",
      autoProcessQueue: false,
      headers: { "X-CSRFToken": $.outdoorish.readCookie("csrftoken") },
      clickable: ["#dropzone-profile-picture", "#dropzone-profile-picture-img"],
      dictInvalidFileType: django.gettext(
        "Only JPG and PNG files are supported."
      ),
      dictFileTooBig: django.gettext(
        "This file exceeds the maximum allowed filesize ({{maxFilesize}} MiB): {{filesize}} MiB"
      ),
      init: function() {
        this.on("thumbnail", function(file, dataUrl) {
          if (this.getQueuedFiles().length > 0) {
            currentAvatarUrl = dataUrl
            $("#dropzone-profile-picture-img").attr("src", dataUrl)
            initDZRemoveButtons()
          }
        })

        this.on("addedfile", function() {
          if (this.files.length === 1) {
            previousAvatarUrl = $("#dropzone-profile-picture-img").attr("src")
            hasCustomAvatar = true
            profileImageDropzoneSuccess = false
            profileImageError = false
            $("#dropzone-profile-picture-upload-text").show()
          }
        })

        this.on("maxfilesexceeded", function(file) {
          $("#dropzone-profile-picture-img").attr("src", previousAvatarUrl)
          this.removeAllFiles(true)
          this.addFile(file)
        })

        this.on("reset", function() {
          hasCustomAvatar = _hasCustomAvatar
          profileImageDropzoneSuccess = undefined
          resetDropzone("#dropzone-profile-picture", previousAvatarUrl)
        })

        this.on("processing", function() {
          $submitButton.prop("disabled", true).addClass("loading-spinner")
        })

        this.on("success", function(file, resp) {
          profileImageMessage.title = resp.title

          if (resp.status === "error") {
            profileImageMessage.content = gettext(
              "Oh no. An Error occurred while uploading {file}. {message}"
            )
              .replace('{file}', file.name)
              .replace('{message}', resp.msg)
            profileImageMessage.type = "danger"
            currentAvatarUrl = previousAvatarUrl
            hasCustomAvatar = _hasCustomAvatar
            profileImageError = true
          } else {
            profileImageDropzoneSuccess = true
            profileImageMessage.content = resp.msg
            profileImageMessage.type = "success"
            previousAvatarUrl = currentAvatarUrl
            _hasCustomAvatar = true
            hasCustomAvatar = true
            $(".profile-avatar").attr("src", currentAvatarUrl)
            $("#user-profile-avatar-img").attr("src", currentAvatarUrl)
          }

          this.removeAllFiles()
        })

        this.on("error", function(file, message, xhr) {
          // Dropzone fires an error event when it's just a maxfilesexceeded event
          // we only want one file so check for that specifically
          // it will be handled by the maxfilesexceeded handler above
          if (this.files.length > 1) {
            return
          }

          profileImageError = true
          currentAvatarUrl = previousAvatarUrl
          hasCustomAvatar = _hasCustomAvatar
          this.removeAllFiles(true)

          profileImageMessage.title = django.gettext("Upload Failed")
          profileImageMessage.type = "danger"

          if (xhr && xhr.response) {
            profileImageMessage.content = gettext(
              "Oh no. An Error occurred while uploading {file}. {message}"
            )
              .replace('{file}', file.name)
              .replace('{message}', JSON.parse(xhr.response).msg['avatar_image'].join(' '))
          } else {
            profileImageMessage.content = message
          }
        })

        this.on("complete", function() {
          if (!$.isEmptyObject(profileImageMessage)) {
            if (!suppressMessages || profileImageError === true) {
              notifications.show({
                title: profileImageMessage.title,
                message: profileImageMessage.content,
                type: profileImageMessage.type
              })
            }
          }
          profileImageMessage = {}
          if (
            profileImageDropzoneSuccess !== false &&
            profileImageDropzoneSuccess !== undefined &&
            profileImageError === false
          ) {
            notifications.show({
              title: formCompleteMessage.title,
              message: formCompleteMessage.content,
              type: formCompleteMessage.type
            })
          }
          $submitButton.prop("disabled", false).removeClass("loading-spinner")
        })
      }
    })

    coverDropzone = new Dropzone("#dropzone-cover-picture", {
      url: context.page('profileBaseUrl') + "settings/upload-cover/",
      acceptedFiles: ".png,.jpg,.jpeg",
      previewTemplate: document.getElementById(
        "dropzone-preview-template-cover-picture"
      ).innerHTML,
      maxFilesize: 3,
      maxFiles: 1,
      thumbnailWidth: null,
      thumbnailHeight: null,
      paramName: "header_image",
      autoProcessQueue: false,
      headers: { "X-CSRFToken": $.outdoorish.readCookie("csrftoken") },
      clickable: ["#dropzone-cover-picture", "#dropzone-cover-picture-img"],
      dictInvalidFileType: django.gettext(
        "Only JPG and PNG files are supported."
      ),
      dictFileTooBig: django.gettext(
        "This file exceeds the maximum allowed filesize ({{maxFilesize}} MiB): {{filesize}} MiB"
      ),
      init: function() {
        this.on("thumbnail", function(file, dataUrl) {
          if (this.getQueuedFiles().length > 0) {
            currentCoverUrl = dataUrl
            $("#dropzone-cover-picture-img").attr("src", dataUrl)
            initDZRemoveButtons()
          }
        })

        this.on("addedfile", function() {
          if (this.files.length === 1) {
            previousCoverUrl = $("#dropzone-cover-picture-img").attr("src")
            hasCustomCover = true
            coverDropzoneSuccess = false
            coverError = false
            $("#dropzone-cover-picture-upload-text").show()
          }
        })

        this.on("maxfilesexceeded", function(file) {
          $("#dropzone-cover-picture-img").attr("src", previousCoverUrl)
          this.removeAllFiles(true)
          this.addFile(file)
        })

        this.on("processing", function() {
          $submitButton.prop("disabled", true).addClass("loading-spinner")
        })

        this.on("reset", function() {
          hasCustomCover = _hasCustomCover
          coverDropzoneSuccess = undefined
          resetDropzone("#dropzone-cover-picture", previousCoverUrl)
        })

        this.on("success", function(file, resp) {
          coverMessage.title = resp.title

          if (resp.status === "error") {
            profileImageMessage.content = gettext(
              "Oh no. An Error occurred while uploading {file}. {message}"
            )
              .replace('{file}', file.name)
              .replace('{message}', resp.msg)
            coverMessage.type = "danger"
            currentCoverUrl = previousCoverUrl
            hasCustomCover = _hasCustomCover
            coverError = true
          } else {
            coverDropzoneSuccess = true
            previousCoverUrl = currentCoverUrl
            _hasCustomCover = true
            hasCustomCover = true
            coverMessage.content = resp.msg
            coverMessage.type = "success"

            // We need to remove the srcset-attribute to disable responsive behaviour
            // file contains the image in its original resolution, so one source suffices
            var profileCover = $("#profile-cover > img")
            profileCover.removeAttr("srcset")
            profileCover.attr("src", file.dataURL)
          }

          this.removeAllFiles()
        })

        this.on("error", function(file, message, xhr) {
          // Dropzone fires an error event when it's just a maxfilesexceeded event
          // we only want one file so check for that specifically
          // it will be handled by the maxfilesexceeded handler above
          if (this.files.length > 1) {
            return
          }

          coverError = true
          currentCoverUrl = previousCoverUrl
          hasCustomCover = _hasCustomCover
          this.removeAllFiles(true)

          coverMessage.title = django.gettext("Upload Failed")
          coverMessage.type = "danger"

          if (xhr && xhr.response) {
            profileImageMessage.content = gettext(
              "Oh no. An Error occurred while uploading {file}. {message}"
            )
              .replace('{file}', file.name)
              .replace('{message}', JSON.parse(xhr.response).msg['header_image'].join(' '))
          } else {
            coverMessage.content = message
          }
        })

        this.on("complete", function() {
          if (!$.isEmptyObject(coverMessage)) {
            if (!suppressMessages || coverError === true) {
              notifications.show({
                title: coverMessage.title,
                message: coverMessage.content,
                type: coverMessage.type
              })
            }
          }
          coverMessage = {}
          if (
            coverDropzoneSuccess !== false &&
            coverDropzoneSuccess !== undefined &&
            coverError === false
          ) {
            notifications.show({
              title: formCompleteMessage.title,
              message: formCompleteMessage.content,
              type: formCompleteMessage.type
            })
          }
          $submitButton.prop("disabled", false).removeClass("loading-spinner")
        })
      }
    })

    $mergeAccountsLink.on("click", function(ev) {
      ev.preventDefault()
      subTabHelpers.activateTab($("#merge-accounts-link"))
      changeSubTab($("#merge-accounts-link"), $activeTab.attr("id"))
    })
  }

  function initMainSettingsForm() {
    var $submitButton = $("#account-settings-form").find("[type='submit']")

    var $accountSettingsForm = $("#account-settings-form")

    var $usernameField = $("#id_new_username")
    var $emailField = $("#id_email")
    var $websiteField = $("#id_website")

    var usernameValidationRequest = null
    var usernameValidationTimeout = null
    var emailValidationRequest = null
    var emailValidationTimeout = null
    var websiteValidationRequest = null
    var websiteValidationTimeout = null

    var $usernameSlug = $("#username_slug", $accountSettingsForm)
    var originalUsernameSlug = $usernameSlug.text()

    suppressMessages = undefined

    function usernameValidationCallback(data) {
      if (data.success === true) {
        $usernameSlug.text(data.current_slug)
      } else {
        $usernameSlug.text(originalUsernameSlug)
      }
    }

    var previousUsername = null
    $usernameField.on("blur", function() {
      if ($usernameField.val() !== previousUsername) {
        previousUsername = $usernameField.val()

        var ret = $.outdoorish.forms.formFieldValidation(
          $usernameField,
          $accountSettingsForm,
          $submitButton,
          CHECK_USERNAME_AVAILABLE_URL,
          usernameValidationRequest,
          usernameValidationTimeout,
          { getSlug: true },
          usernameValidationCallback
        )

        usernameValidationRequest = ret.ajaxRequest
        usernameValidationTimeout = ret.timeout
      }
    })

    var previousEmail = null
    $emailField.on("blur", function() {
      if ($emailField.val() !== previousEmail) {
        previousEmail = $emailField.val()

        var ret = $.outdoorish.forms.formFieldValidation(
          $emailField,
          $accountSettingsForm,
          $submitButton,
          CHECK_EMAIL_AVAILABLE_URL,
          emailValidationRequest,
          emailValidationTimeout
        )

        emailValidationRequest = ret.ajaxRequest
        emailValidationTimeout = ret.timeout
      }
    })

    var previousWebsite = null
    $websiteField.on("blur", function() {
      if ($websiteField.val() !== previousWebsite) {
        previousWebsite = $websiteField.val()

        var ret = $.outdoorish.forms.formFieldValidation(
          $websiteField,
          $accountSettingsForm,
          $submitButton,
          context.page('checkIsValidUrl'),
          websiteValidationRequest,
          websiteValidationTimeout
        )

        websiteValidationRequest = ret.ajaxRequest
        websiteValidationTimeout = ret.timeout
      }
    })

    $accountSettingsForm.on("submit", function(ev) {
      $submitButton.prop("disabled", true).addClass("loading-spinner")
      var formData = new FormData(this)
      ev.preventDefault()
      $.ajax({
        form: $accountSettingsForm,
        formSuccessCallback: mainSettingsFormCallBack,
        url: this.action,
        method: "POST",
        data: formData,
        processData: false,
        contentType: false,
        headers: { "X-CSRFToken": $.outdoorish.readCookie("csrftoken") },
        busyElement: $submitButton,
        busyClass: "loading-spinner",
        complete: $.outdoorish.forms.handleAjaxFormErrors,
        success: function(data) {
          if (data.success === true) {
            $(".title-content .title").text(data.fields.fullname)
            $("#name-breadcrumb").text(data.fields.fullname)
            $(".user-about").text(data.fields.biography)
            if (data.fields.website) {
              $("#user-website-link")
                .attr("href", data.fields.website)
                .text(data.fields.website)
              $("#user-website").show()
            } else {
              $("#user-website").hide()
            }
            if (data.fields.country) {
              $("#user-location-text").html(data.fields.country)
              $("#user-location").show()
            } else {
              $("#user-location").hide()
            }
          }
        }
      })
    })
    initDZRemoveButtons()

    $.outdoorish.initAutocomplete("#location-autocomplete")
    Typeahead[
      "#location-autocomplete-input"
    ].options.callback.onCancel = function() {
      $("#location-autocomplete-input-id").val("")
      $("#location-autocomplete-input-class").val("")
    }
  }

  var initNotificationSettingsForm = function() {
    var notificationSettingsForm = $("#notification-settings-form")
    var notificationSettingsSubmitButton = notificationSettingsForm.find(
      'button[type="submit"]'
    )

    notificationSettingsForm.on("submit", function(event) {
      event.preventDefault()
      notificationSettingsSubmitButton
        .prop("disabled", true)
        .addClass("loading-spinner")
      $.ajax(this.action, {
        method: "POST",
        headers: { "X-CSRFToken": $.outdoorish.readCookie("csrftoken") },
        data: new FormData(this),
        processData: false,
        contentType: false,
        form: notificationSettingsForm,
        busyElement: notificationSettingsSubmitButton,
        busyClass: "loading-spinner",
        complete: $.outdoorish.forms.handleAjaxFormErrors,
        formSuccessCallback: function(msg, url) {
          if (url !== undefined) {
            location.href = url
          }

          notifications.show({
            title: msg.finished.title,
            icon: "i-check",
            message: msg.finished.content,
            type: "success"
          })
        }
      })
    })
  }

  var initTrainingLog = function(config) {
    function initListView() {
      $(".tab-switch.listview").on("click", function() {
        var entries = $(".trainingsentries")
        if (entries.hasClass("gridview")) {
          entries.removeClass("gridview")
          entries.addClass("listview")
        }
      })

      $(".tab-switch.gridview").on("click", function() {
        var entries = $(".trainingsentries")
        if (entries.hasClass("listview")) {
          entries.removeClass("listview")
          entries.addClass("gridview")
        }
      })
    }

    function updateTrainingList(event) {
      event.preventDefault()

      // Add busy indicator to list
      $("#training-log-main").fadeTo("fast", 0.25)
      $("#loading-content").show()

      // Get new markup from server
      $.ajax({
        type: "GET",
        url: this.dataset.url,
        headers: isOwner
          ? { "Is-Owner": "True", "Only-Tab": "True" }
          : { "Only-Tab": "True" },
        data: { date: this.dataset.parameters.split("=")[1] },
        success: function(data) {
          var activeTab = "training-log"
          activeSubTabs[activeTab].trigger("unload-sub-tab")
          activeSubTabs[activeTab].removeClass("active")
          activeSubTabs[activeTab].parent("#sub-tab-content").append(data.html)
          activeSubTabs[activeTab].remove()
          activeSubTabs[activeTab] = $("#" + data.active_sub_tab)
          activeSubTabs[activeTab]
            .parent("#sub-tab-content")
            .children(".active")
            .removeClass("active")
          activeSubTabs[activeTab].addClass("active")

          initSubTab(data.active_sub_tab, data)
        }
      })

      return false
    }

    $.outdoorish.graph.createGraph(config)
    $(".prev-week, .next-week").on("click", updateTrainingList)
    initListView()

    // Bind left and right arrow keys
    /* $(document).keydown(function (e) {
            var keyCode = e.which,
                arrow = {left: 37, up: 38, right: 39, down: 40};

            switch (keyCode) {
                case arrow.left:
                    window.location.href = $('.prev-week').attr('href');
                    break;
                case arrow.right:
                    window.location.href = $('.next-week').attr('href');
                    break;
            }
        }); */

    // show buttons only on hover
    $(".tile-training")
      .on("mouseenter", function() {
        $(".tile-buttons span", $(this)).show()
      })
      .on("mouseleave", function() {
        $(".tile-training .tile-buttons span").hide()
      })
  }

  function mainSettingsFormCallBack(msg, url) {
    if (url !== undefined) {
      location.href = url
    }

    var sendMessage = true
    formCompleteMessage = {
      title: msg.finished.title,
      icon: "check",
      content: msg.finished.content,
      type: "success"
    }

    if (profileImageDropzone.getQueuedFiles().length > 0) {
      sendMessage = false
      $("#profile-picture-upload-progress").show()
      profileImageDropzone.processQueue()
    }

    if (coverDropzone.getQueuedFiles().length > 0) {
      sendMessage = false
      $("#cover-picture-upload-progress").show()
      coverDropzone.processQueue()
    }

    if (sendMessage) {
      notifications.show({
        title: formCompleteMessage.title,
        icon: formCompleteMessage.icon,
        message: formCompleteMessage.content,
        type: formCompleteMessage.type
      })
    }
  }

  function initPasswordResetForm() {
    const passwordField = new InitPasswordField(document.getElementById('account-password-reset-form'))
    passwordField.render()

    $("#account-password-reset-form").on("submit", function(ev) {
      var formData = new FormData(this)
      $("#account-password-reset-form [type='submit']")
        .prop("disabled", true)
        .addClass("loading-spinner")
      ev.preventDefault()
      $.ajax({
        busyElement: $("#account-password-reset-form [type='submit']"),
        busyClass: "loading-spinner",
        form: $("#account-password-reset-form"),
        formSuccessCallback: function(msg) {
          notifications.show({
            title: msg.title,
            icon: "i-check",
            message: msg.content,
            type: "success"
          })
          $("#account-password-reset-form")[0].reset()
          $("#account-password-reset-form input.error").removeClass("error")
        },
        success: function(data) {
          if (data && data.hasOwnProperty('redirect') && data.redirect.length > 0) {
            window.location.replace(data.redirect)
          }
        },
        url: this.action,
        method: "POST",
        data: formData,
        processData: false,
        contentType: false,
        headers: { "X-CSRFToken": $.outdoorish.readCookie("csrftoken") },
        complete: $.outdoorish.forms.handleAjaxFormErrors
      })
    })
  }

  function unloadMergeAccountsFromTokenSubTab() {
    delete loadedSubTabs
      .settings[$.inArray("merge-accounts", loadedSubTabs.settings)]
    $("#merge-accounts-form").off("submit")
    activeSubTabs.settings.off(
      "unload-sub-tab",
      unloadMergeAccountsFromTokenSubTab
    )

    var $placeholder = $('<div id="merge-accounts-placeholder"></div>')
    activeSubTabs.settings.parent("#sub-tab-content").append($placeholder)
    activeSubTabs.settings.remove()
    activeSubTabs.settings = $placeholder
    removeBreadCrumb("settings-main-breadcrumb-link", 3)
  }

  /**
   * Tabs
   */
  function loadOwnerData() {
    $("#settings-link").removeClass("hidden")
    $("#training-log-link").removeClass("hidden")
    initAvatar()
  }

  var changeTab = function(elem, noHistory, useCurrentLocation) {
    var id = elem.attr("id")
    var name = id.slice(0, id.lastIndexOf("-"))
    var url

    $("a.tab-link").addClass("disabled")
    if (useCurrentLocation === true) {
      var currentPath = location.pathname.split("/")
      var subTabName = currentPath[currentPath.length - 2]

      if (subTabName.slice(-4) === "main") {
        url = currentPath.slice(0, -2).join("/") + "/"
      } else {
        url = location.pathname
      }
      // Proxing page query string to tab handler
      url = url + window.location.search
    } else {
      url = context.page('profileBaseUrl') + name + "/"
    }

    tabHelpers.hideTabContent()
    tabHelpers.activateTab(elem)

    if ($.inArray(name, loadedTabs) > -1 && !elem[0].dataset.dirty) {
      tabHelpers.showTabContent(name)

      if (noHistory === undefined) {
        history.pushState(
          { previousTabName: "#" + id, previousSubTab: false },
          $("#" + $activeTab.attr("id") + "-link").text(),
          url
        )
      }
      initTab(name)
    } else {
      $.ajax({
        url: url,
        type: "get",
        dataType: "json",
        headers: isOwner ? { "Is-Owner": "True" } : {},
        success: function(data) {
          if (data.redirect) {
            window.location.replace(data.redirect)
            return
          }

          const oldTabContent = $('#' + name)
          if (oldTabContent.length) {
            oldTabContent.remove()
            delete elem[0].dataset.dirty
          } else {
            loadedTabs.push(name)
          }
          $("#tab_content").append(data.html)

          tabHelpers.showTabContent(name)

          if (noHistory === undefined) {
            history.pushState(
              { previousTabName: "#" + id, previousSubTab: false },
              $("#" + $activeTab.attr("id") + "-link").text(),
              url
            )
          }
          initTab(name, data)
        },
        error: function() {
          $("a.tab-link").removeClass("disabled")
        }
      })
    }
  }

  function removeBreadCrumb(link, fromIndex) {
    var breadcrumbText

    var $breadcrumbListItems = $breadcrumbList.children()
    $breadcrumbListItems.each(function(index) {
      if (index >= fromIndex) {
        $(this).remove()
      }
    })
    $breadcrumbListItems = $breadcrumbList.children()
    breadcrumbText = $breadcrumbListItems.last().text()
    $breadcrumbListItems.last().empty()
    $breadcrumbListItems.last().text(breadcrumbText)
    $breadcrumbListItems.last().addClass("active")
    if (link) {
      $breadcrumbList
        .children()
        .find("#" + link + "-breadcrumb-link")
        .off("click")
    }
  }

  function addBreadCrumb(link, name, activeTab) {
    var $breadcrumbListItems = $breadcrumbList.children()

    var breadcrumbText
    breadcrumbText = $breadcrumbListItems.last().text()
    $breadcrumbListItems.last().removeClass("active")
    $breadcrumbListItems.last().empty()

    if (link === 'name') {
      $breadcrumbListItems
        .last()
        .append(
          '<span id="' +
            link +
            "-breadcrumb" +
            '">' +
            breadcrumbText +
            "</span>" +
            '<i class="i-chevron-right text-secondary"></i>'
        )
    } else {
      var url = context.page('profileBaseUrl') + link + "/"
      $breadcrumbListItems
        .last()
        .append(
          '<a id="' +
            link +
            "-breadcrumb-link" +
            '" href="' +
            url +
            '">' +
            breadcrumbText +
            "</a>" +
            '<i class="i-chevron-right text-secondary"></i>'
        )
      $breadcrumbList
        .children()
        .find("#" + link + "-breadcrumb-link")
        .on("click", function(ev) {
          ev.preventDefault()
          if (activeTab === undefined) {
            changeTab($("#" + link + "-link"))
          } else {
            changeSubTab($("#" + link + "-link"), activeTab)
          }
        })
    }

    breadcrumbText = $("#" + name + "-link").text()
    $breadcrumbList.append('<li class="active">' + breadcrumbText + "</li>")
  }

  function initTab(name, data) {
    currentPath = location.pathname
    var subTabId
    var state = history.state

    switch (name) {
      case "routes":
        addBreadCrumb('name', name)
        if (data === undefined) {
          setupSubtabsClickHandler(name)
          if (!isNavigatingHistory) {
            subTabId = activeSubTabs[name].attr("id")
            state.previousSubTab = "#" + subTabId + "-link"
            history.replaceState(
              state,
              $("#" + subTabId + "-link").text(),
              context.page('profileBaseUrl') + "routes/" + subTabId.split("-")[1] + "/"
            )
            addBreadCrumb("routes-created", subTabId, "routes")
          }
        } else {
          initSubTabs(name, data.active_sub_tab, data)
          $activeTab.on("unload-tab", function() {
            $("#" + name + ' [role="sub-tab"]').off("click")
            removeBreadCrumb(null, 2)
          })
        }
        break
      case "collections":
        addBreadCrumb('name', name)
        if (data !== undefined) {
          $activeTab.on("unload-tab", function() {
            removeBreadCrumb(null, 2)
          })

          loadRouteData(data.results, name)
          initRoutes(
            {
              resultsContainer: "#tiles-container-collections",
              controlsContainer: "#controls-container-collections",
              noResults: "#search-no-collections"
            },
            name,
            activeLayout
          )

          const pagination = new Pagination({
            numPages: savedResults.collections.numPages,
            currentPage: savedResults.collections.page,
            onChange: pageNumber => {
              savedResults.collections.page = pageNumber
              submitSearch(savedResults.collections)
            }
          })
          document.querySelector('#collections .pagination-centered').append(pagination.render())

          initPaginationSortLinks(name, pagination)
          initCreateCollectionForm()
        }

        break
      case "training-log":
        addBreadCrumb('name', name)
        if (data === undefined) {
          setupSubtabsClickHandler(name)
          if (!isNavigatingHistory) {
            subTabId = activeSubTabs[name].attr("id")
            state.previousSubTab = "#" + subTabId + "-link"

            // Url and element id don't always agree (and don't really have to in principle)
            var subTabHistoryId = subTabId
            if (subTabHistoryId === "add-training-entry") {
              subTabHistoryId = "add-entry"
            } else if (subTabHistoryId === "all-trainings") {
              subTabHistoryId = "all"
            }

            if (subTabHistoryId.slice(-4) === "main") {
              history.replaceState(
                state,
                $("#" + subTabId + "-link").text(),
                context.page('profileBaseUrl') + "training-log/"
              )
            } else {
              history.replaceState(
                state,
                $("#" + subTabId + "-link").text(),
                context.page('profileBaseUrl') + "training-log/" + subTabHistoryId + "/"
              )
            }

            addBreadCrumb("training-log-main", subTabId, "training-log")
          }
        } else {
          initSubTabs(name, data.active_sub_tab, data)
          $activeTab.on("unload-tab", function() {
            $("#" + name + ' [role="sub-tab"]').off("click")
            removeBreadCrumb(null, 2)
          })
        }
        break
      case "settings":
        addBreadCrumb('name', name)
        if (data === undefined) {
          setupSubtabsClickHandler(name)
          if (!isNavigatingHistory) {
            subTabId = activeSubTabs[name].attr("id")
            state.previousSubTab = "#" + subTabId + "-link"

            if (subTabId.slice(-4) === "main") {
              history.replaceState(
                state,
                $("#" + subTabId + "-link").text(),
                context.page('profileBaseUrl') + "settings/"
              )
            } else {
              history.replaceState(
                state,
                $("#" + subTabId + "-link").text(),
                context.page('profileBaseUrl') + "settings/" + subTabId + "/"
              )
            }

            addBreadCrumb("settings-main", subTabId, "settings")
          }
        } else {
          initSubTabs(name, data.active_sub_tab, data)
          $activeTab.on("unload-tab", function() {
            $("#" + name + ' [role="sub-tab"]').off("click")
            removeBreadCrumb(null, 2)
          })
        }
        break
      default:
        break
    }

    $("a.tab-link").removeClass("disabled")
    tabHelpers.hideLoadingSpinner()
    return false
  }

  function setupSubtabsClickHandler(activeTab) {
    $("#" + activeTab + ' [role="sub-tab"]').on("click", function(ev) {
      ev.preventDefault()

      var forceReload = this.classList.contains("force-reload")

      if (
        (!this.classList.contains("active") ||
          this.classList.contains("ignore-active")) &&
        !this.classList.contains("disabled")
      ) {
        changeSubTab($(this), activeTab, undefined, forceReload)
      }
    })
  }

  function initSubTabs(activeTab, activeSubTab, data) {
    loadedSubTabs[activeTab] = [activeSubTab]
    activeSubTabs[activeTab] = $("#" + activeSubTab)
    $initialSubTab = $("#" + activeSubTab + "-link")
    $initialSubTab.addClass("active")
    history.replaceState(
      {
        previousTabName: "#" + activeTab + "-link",
        previousSubTab: "#" + activeSubTab + "-link"
      },
      $initialSubTab.text()
    )
    initSubTab(activeSubTab, data)
    setupSubtabsClickHandler(activeTab)
  }

  function onActiveLayoutChange(controlsContainerId, newLayout) {
      var $changeLayoutToGrid = $(
        "#view-mode-grid",
        controlsContainerId
      )
      var $changeLayoutToList = $(
        "#view-mode-list",
        controlsContainerId
      )

      if (newLayout === "grid") {
        $changeLayoutToGrid.addClass("view-mode-active")
        $changeLayoutToList.removeClass("view-mode-active")
      } else {
        $changeLayoutToGrid.removeClass("view-mode-active")
        $changeLayoutToList.addClass("view-mode-active")
      }
  }

  function initSubTab(name, data) {
    currentPath = location.pathname
    switch (name) {
      case "settings-main":
        if (data === undefined) {
          var i
          coverDropzone.enable()
          for (i = 0; i < coverDropzoneFiles.length; i++) {
            coverDropzone.addFile(coverDropzoneFiles[i])
          }
          profileImageDropzone.enable()
          for (i = 0; i < profileImageDropzoneFiles.length; i++) {
            profileImageDropzone.addFile(profileImageDropzoneFiles[i])
          }
        } else {
          setupMainSettingsForm()
          activeSubTabs.settings.on("unload-sub-tab", function() {
            $("#dropzone-profile-picture-remove").off("click")
            $("#dropzone-cover-picture-remove").off("click")
            $("#dropzone-profile-picture-confirm").off("click")
            $("#dropzone-cover-picture-confirm").off("click")
            $("#account-settings-form").off("submit")
            suppressMessages = true
            coverDropzoneFiles = coverDropzone.getQueuedFiles()
            coverDropzone.disable()
            profileImageDropzoneFiles = profileImageDropzone.getQueuedFiles()
            profileImageDropzone.disable()
            removeBreadCrumb("settings-main", 3)
          })
        }
        initMainSettingsForm()
        break
      case "garmin":
        if (data !== undefined) {
          if ($("#garmin-connect-connected").data("connected") === false) {
            $("#garmin-connect-logo").addClass("cursor-pointer")
            $("#garmin-connect-subtext").addClass("cursor-pointer")
            $("#garmin-connect-logo").on("click", function() {
                $("#garmin-connect-form").submit()
            })
            $("#garmin-connect-subtext").on("click", function() {
                $("#garmin-connect-form").submit()
            })
          }
          activeSubTabs.settings.on("unload-sub-tab", function() {
            $("#garmin-connect-form").off("submit")
            $("#garmin-disconnect-form").off("submit")
            removeBreadCrumb("settings-main", 3)
          })
        }
        initGarminConnectForm()
        addBreadCrumb("settings-main", name, "settings")
        break
      case "notification-settings":
        if (data !== undefined) {
          activeSubTabs.settings.on("unload-sub-tab", function() {
            $("#notification-settings-form").off("submit")
            removeBreadCrumb("settings-main", 3)
          })
        }
        initNotificationSettingsForm()
        addBreadCrumb("settings-main", name, "settings")

        break
      case "change-password":
        if (data !== undefined) {
          activeSubTabs.settings.on("unload-sub-tab", function() {
            $("#account-password-reset-form").off("submit")
            removeBreadCrumb("settings-main", 3)
          })
        }
        initPasswordResetForm()
        addBreadCrumb("settings-main", name, "settings")
        break
      case "delete-account":
        if (data !== undefined) {
          activeSubTabs.settings.on("unload-sub-tab", function() {
            $("#account-delete-form").off("submit")
            removeBreadCrumb("settings-main-breadcrumb-link", 3)
          })
        }
        initDeleteAccountForm()
        addBreadCrumb("settings-main", name, "settings")
        break
      case "merge-accounts":
        if (data !== undefined) {
          if ($("#merge-accounts-placeholder").length > 0) {
            $("#merge-accounts-placeholder").remove()
          }
          activeSubTabs.settings.on(
            "unload-sub-tab",
            unloadMergeAccountsFromTokenSubTab
          )
          if (data.message) {
            notifications.show({
              title: data.title,
              icon: data.icon,
              message: data.message,
              type: data.message_type
            })
          }
        }
        initMergeAccountsForm()
        addBreadCrumb("settings-main", name, "settings")
        break
      case "routes-created":
      case "routes-ridden":
      case "routes-favorites":
      case "routes-tracked":
        var activeSubTabConfig = subTabConfig[name]

        if (data !== undefined) {
          activeSubTabs.routes.on("unload-sub-tab", function() {
            removeBreadCrumb(name, 3)
          })

          activeSubTabs.routes.on("show-sub-tab", function() {
            var controlsContainerId = activeSubTabConfig.controlsContainer
            var activeTabLayout =
              $(controlsContainerId + " grid").length > 0 ? "grid" : "list"

            // Refresh layout if needed
            if (!activeTabLayout || activeTabLayout !== activeLayout) {
              var $container = $(activeSubTabConfig.resultsContainer)
              $.outdoorish.initMixItUp(
                controlsContainerId,
                $container,
                {
                  animation: {},
                  layout: {
                    containerClass: activeLayout
                  }
                },
                onLayoutUpdate
              )

              onActiveLayoutChange(controlsContainerId, activeLayout)

              if ($container.mixItUp("isLoaded")) {
                $container.mixItUp(
                  "changeLayout",
                  {
                    containerClass: activeLayout
                  },
                  false
                )
              }
            }
          })

          loadRouteData(data.results, name)

          // Apply search if local/client sort is different from backend sort
          if (isClientSortDifferent) {
            submitSearch(savedResults[name])
            var newSortItem = $("#sort-" + name).find('.sort-link[data-sort="' + savedResults[name].sorting + '"]')
            onSortChange(name, newSortItem.html())
          }

          // Update UI if local/client layout is different from default one
          if (isClientLayoutDifferent) {
              onActiveLayoutChange(activeSubTabConfig.controlsContainer, activeLayout)
          }

          initRoutes(activeSubTabConfig, name, activeLayout)

          const pagination = new Pagination({
            numPages: savedResults[name].numPages,
            currentPage: savedResults[name].page,
            onChange: pageNumber => {
              savedResults[name].page = pageNumber
              submitSearch(savedResults[name])
            }
          })
          document.querySelector(`#${name} .pagination-centered`).append(pagination.render())

          initPaginationSortLinks(name, pagination)
        }

        addBreadCrumb(name, name, "routes")
        break
      case "training-log-main":
        if (data !== undefined) {
          activeSubTabs["training-log"].on("unload-sub-tab", function() {
            removeBreadCrumb("training-log-main", 3)
          })

          if (data.config !== undefined) {
            data.config.infos = JSON.parse(data.config.infos)
            initTrainingLog(data.config)
            initTrainingItemButtons()
          }
        }
        break
      case "all-trainings":
        if (data !== undefined) {
          activeSubTabs["training-log"]
            .on("unload-sub-tab", function() {
              removeBreadCrumb("training-log-main", 3)
            })
            .on("remove-sub-tab", function() {
              var $resultsContainer = $("#tiles-container-all-trainings")
              if ($resultsContainer.mixItUp("isLoaded")) {
                $resultsContainer.mixItUp("destroy")
              }

              $resultsContainer.empty()
            })

          loadTrainingData(data.results)
          initRoutes(
            {
              resultsContainer: "#tiles-container-all-trainings",
              noResults: "#search-no-all-trainings"
            },
            name,
            "list"
          )

          initTrainingItemButtons()

          const pagination = new Pagination({
            numPages: savedResults["all-trainings"].numPages,
            currentPage: savedResults["all-trainings"].page,
            onChange: pageNumber => {
              savedResults["all-trainings"].page = pageNumber
              submitSearch(savedResults["all-trainings"])
            }
          })
          document.querySelector('#all-trainings .pagination-centered').append(pagination.render())

          initPaginationSortLinks(name, pagination)
        }

        addBreadCrumb("all-trainings", name, "training-log")
        break
      case "edit-training-entry":
        if (data !== undefined) {
          activeSubTabs["training-log"].on("unload-sub-tab", function() {
            $("#training-log-main-link").show()
            $("#add-training-entry-link").show()
            $("#" + name + "-link").hide()
          })
        }

        $("#training-log-main-link").hide()
        $("#add-training-entry-link").hide()

        $(".cancel-edit").on("click", function() {
          changeSubTab($("#training-log-main-link"), "training-log")
        })
      case "add-training-entry":
        if (data !== undefined) {
          activeSubTabs["training-log"].on("unload-sub-tab", function() {
            $("#training-edit-form").off("submit")
            removeBreadCrumb("add-training-entry", 3)
          })
        }

        initTrainingEntryTab()

        addBreadCrumb("training-log-main", name, "training-log")
        break
      case "manage-subscription":
        if (data !== undefined) {
          activeSubTabs.settings.on("unload-sub-tab", function() {
            $("#billing-details-link").off("click")
            $("#re-activate-subscription").off("submit")
            removeBreadCrumb("settings-main", 3)
          })
        }
        initSubscriptionTab()
        addBreadCrumb("settings-main", name, "settings")
        break
      default:
        break
    }
    $("a.tab-link").removeClass("disabled")
    subTabHelpers.hideLoadingSpinner()
  }

  function changeSubTab(elem, activeTab = $activeTab.attr("id"), noHistory, forceReload) {
    var id = elem.attr("id")
    var name = id.slice(0, id.lastIndexOf("-"))
    var url = elem[0].pathname

    if (noHistory && url !== location.pathname) {
      url = location.pathname
    }

    $("a.tab-link").addClass("disabled")

    subTabHelpers.activateTab(elem)
    subTabHelpers.hideTabContent(activeTab)

    if (
      !(forceReload === true || elem[0].dataset.dirty) &&
      $.inArray(name, loadedSubTabs[activeTab]) > -1
    ) {
      subTabHelpers.showTabContent(activeTab, name)
      if (noHistory === undefined) {
        history.pushState(
          {
            previousTabName: "#" + $activeTab.attr("id") + "-link",
            previousSubTab: "#" + id
          },
          $("#" + activeSubTabs[activeTab].attr("id") + "-link").text(),
          url
        )
      }
      initSubTab(name)
    } else {
      $.ajax({
        url: url,
        type: "get",
        headers: isOwner
          ? { "Is-Owner": "True", "Only-Tab": "True" }
          : { "Only-Tab": "True" },
        dataType: "json",
        success: function(data) {
          if (data.redirect) {
            window.location.replace(data.redirect)
            return
          }
          var $subTabContent = activeSubTabs[activeTab].parent(
            "#sub-tab-content"
          )

          if ($.inArray(name, loadedSubTabs[activeTab]) > -1) {
            loadedSubTabs[activeTab].splice(
              loadedSubTabs[activeTab].indexOf(name),
              1
            )

            var $previousSubTabContent = $("#" + name)
            $previousSubTabContent.trigger("remove-sub-tab")
            $previousSubTabContent.remove()
          }

          loadedSubTabs[activeTab].push(name)
          $subTabContent.append(data.html)
          subTabHelpers.showTabContent(activeTab, name)
          if (noHistory === undefined) {
            history.pushState(
              {
                previousTabName: "#" + $activeTab.attr("id") + "-link",
                previousSubTab: "#" + id
              },
              $("#" + activeSubTabs[activeTab].attr("id") + "-link").text(),
              url
            )
          }
          initSubTab(name, data)
        },
        error: function() {
          $("a.tab-link").removeClass("disabled")
        }
      })

      if (elem[0].dataset.dirty) {
        delete elem[0].dataset.dirty
      }
    }
  }

  /**
   * Global functions
   */
  function initAvatar() {
    var _hasCustomAvatar = hasCustomAvatar

    function resetDropzone() {
      $("#user-profile-avatar-controls").removeClass("hidden")
      $("#user-profile-avatar-confirm").off("click")
      $("#user-profile-avatar-confirm").remove()
      $("#user-profile-avatar-remove").off("click")
      $("#user-profile-avatar-remove").remove()
      $("#avatar-upload-text").hide()
      $("#user-profile-avatar-img").attr("src", currentAvatarUrl)
    }

    $("#user-profile-avatar").removeClass("hidden")

    var dropzoneAvatar = new Dropzone("#user-profile-avatar", {
      url: context.page('profileBaseUrl') + "settings/upload-avatar/",
      acceptedFiles: ".png,.jpg,.jpeg",
      previewTemplate: $("#dropzone-preview-template-avatar").html(),
      maxFilesize: 3,
      maxFiles: 1,
      thumbnailHeight: 160,
      thumbnailWidth: 160,
      paramName: "avatar_image",
      autoProcessQueue: false,
      headers: { "X-CSRFToken": $.outdoorish.readCookie("csrftoken") },
      clickable: "#user-profile-avatar-container",
      dictInvalidFileType: django.gettext(
        "Only JPG and PNG files are supported."
      ),
      dictFileTooBig: django.gettext(
        "This file exceeds the maximum allowed filesize ({{maxFilesize}} MiB): {{filesize}} MiB"
      ),
      init: function() {
        this.on("thumbnail", function(file, dataUrl) {
          if (this.getQueuedFiles().length > 0) {
            var html =
              '<div id="user-profile-avatar-confirm" class="avatar-confirm">' +
              '<i class="i-check text-success avatar-confirm-icon"></i>' +
              "</div>" +
              '<div id="user-profile-avatar-remove" class="avatar-remove">' +
              '<i class="i-delete text-danger icon-remove avatar-remove-icon"></i>' +
              "</div>"

            currentAvatarUrl = dataUrl
            $("#user-profile-avatar-img").attr("src", dataUrl)
            $("#user-profile-avatar-controls")
              .children(":first")
              .after(html)
            $("#user-profile-avatar-confirm").on("click", function(event) {
              event.stopPropagation()
              $("#avatar-upload-progress").show()
              $("#user-profile-avatar-controls").addClass("hidden")
              dropzoneAvatar.processQueue()
            })

            $("#user-profile-avatar-remove").on("click", function(event) {
              event.stopPropagation()
              currentAvatarUrl = previousAvatarUrl
              dropzoneAvatar.removeAllFiles(true)
            })

            $("#user-profile-avatar")
              .addClass("avatar-hovered")
              .on("mouseleave", function() {
                $("#user-profile-avatar")
                  .removeClass("avatar-hovered")
                  .off("mouseleave")
              })
          }
        })

        this.on("addedfile", function() {
          if (this.files.length === 1) {
            previousAvatarUrl = $("#user-profile-avatar-img").attr("src")
            hasCustomAvatar = true
            $("#avatar-upload-text").show()
          }
        })

        this.on("maxfilesexceeded", function(file) {
          $("#user-profile-avatar-img").attr("src", previousAvatarUrl)
          this.removeAllFiles(true)
          this.addFile(file)
        })

        this.on("reset", function() {
          hasCustomAvatar = _hasCustomAvatar
          resetDropzone("#user-profile-avatar", previousAvatarUrl)
        })

        this.on("success", function(file, resp) {
          if (resp.status === "error") {
            const message = gettext(
              "Oh no. An Error occurred while uploading {file}. {message}"
            )
              .replace('{file}', file.name)
              .replace('{message}', resp.msg)
            notifications.error(message, resp.title)
            currentAvatarUrl = previousAvatarUrl
            hasCustomAvatar = _hasCustomAvatar
          } else {
            notifications.show({
              title: resp.title,
              message: resp.msg,
              type: 'success'
            })
            previousAvatarUrl = currentAvatarUrl
            _hasCustomAvatar = true
            hasCustomAvatar = true
            $(".profile-avatar").attr("src", currentAvatarUrl)
            $("#user-profile-avatar-img").attr("src", currentAvatarUrl)
          }

          this.removeAllFiles()
        })

        this.on("error", function(file, message, xhr) {
          // Dropzone fires an error event when it's just a maxfilesexceeded event
          // we only want one file so check for that specifically
          // it will be handled by the maxfilesexceeded handler above
          if (this.files.length > 1) {
            return
          }

          currentAvatarUrl = previousAvatarUrl
          hasCustomAvatar = _hasCustomAvatar
          this.removeAllFiles(true)

          if (xhr && xhr.response) {
            const res = JSON.parse(xhr.response)
            notifications.error(res.msg['avatar_image'].join(' '), res.title)
          } else {
            notifications.error(message, django.gettext("Upload Failed"))
          }
        })
      }
    })
  }

  $.ajax({
    url: context.page('profileBaseUrl') + "is-owner/",
    type: "GET",
    dataType: "json",
    headers: { "Cache-Control": "no-cache", "Ignore-It": "True" },
    success: function(data) {
      isOwner = data.isOwner
      if (isOwner === true) {
        loadOwnerData()
      }

      changeTab($("#" + activeTab + "-link"), true, true)
    }
  })

  window.onpopstate = function(e) {
    if (location.pathname !== currentPath) {
      isNavigatingHistory = true

      if (e.state.previousSubTab === false) {
        changeTab($(e.state.previousTabName), true)
      } else {
        changeTab($(e.state.previousTabName), true)
        changeSubTab($(e.state.previousSubTab), $activeTab.attr("id"), true)
      }

      isNavigatingHistory = false
    }
  }

  /* Hack for active states, as the tabs aren't Bootstrap-compliant list elements but wrapped in responsive columns. */
  $('[role="tab"]').on("click", function(ev) {
    ev.preventDefault()

    if (
      !this.classList.contains("active") &&
      !this.classList.contains("disabled")
    ) {
      changeTab($(this))
    }
  })
})
